'use client';

import { SocialTwitter } from '@doist/icons/base';
import { Android, Apple } from '@doist/icons/brand';
import { ReviewBox } from '@doist/marketist';
import Interpolate from 'components/Interpolate/Interpolate';
import { type TFunction } from 'i18next';
import { useLocalisedTweetInfo } from './tweet-map';
function playStoreAllowed(lang: string) {
  return !['ru', 'zh-CN'].includes(lang);
}
function ReviewEvnsio({
  t
}: {
  t: TFunction;
}) {
  const {
    avatar,
    link
  } = useLocalisedTweetInfo('evnsio');
  return <ReviewBox citation={<ReviewBox.TwitterCitation label={t('reviewEvnsio.name')} avatar={{
    src: avatar,
    alt: t('profilePictureAlt', {
      name: t('reviewEvnsio.name')
    })
  }} tweetLink={link} icon={SocialTwitter} />} data-sentry-element="ReviewBox" data-sentry-component="ReviewEvnsio" data-sentry-source-file="reviews.tsx">
            {<Interpolate t={t} i18nKey={'reviewEvnsio.quote'} />}
        </ReviewBox>;
}
function ReviewKaiinde({
  t,
  lang
}: {
  t: TFunction;
  lang: string;
}) {
  return <ReviewBox citation={<ReviewBox.AppReviewCitation label={t('reviewKaiinde.name')} icon={playStoreAllowed(lang) ? Android : Apple} stars={5} starsAriaLabel={t('starsAriaLabel', {
    stars: 5
  })} />} data-sentry-element="ReviewBox" data-sentry-component="ReviewKaiinde" data-sentry-source-file="reviews.tsx">
            {<Interpolate t={t} i18nKey={'reviewKaiinde.quote'} />}
        </ReviewBox>;
}
function ReviewAeravi({
  t,
  lang
}: {
  t: TFunction;
  lang: string;
}) {
  return <ReviewBox citation={<ReviewBox.AppReviewCitation label={t('quoteAeravi.name')} icon={playStoreAllowed(lang) ? Android : Apple} stars={5} starsAriaLabel={t('starsAriaLabel', {
    stars: 5
  })} />} data-sentry-element="ReviewBox" data-sentry-component="ReviewAeravi" data-sentry-source-file="reviews.tsx">
            {<Interpolate t={t} i18nKey={'quoteAeravi.quote'} />}
        </ReviewBox>;
}
function ReviewNotJulien({
  t
}: {
  t: TFunction;
}) {
  const {
    avatar,
    link
  } = useLocalisedTweetInfo('notJulien');
  return <ReviewBox citation={<ReviewBox.TwitterCitation label={t('quoteNotJulien.name')} avatar={{
    src: avatar,
    alt: t('profilePictureAlt', {
      name: t('quoteNotJulien.name')
    })
  }} tweetLink={link} icon={SocialTwitter} />} data-sentry-element="ReviewBox" data-sentry-component="ReviewNotJulien" data-sentry-source-file="reviews.tsx">
            {<Interpolate t={t} i18nKey={'quoteNotJulien.quote'} />}
        </ReviewBox>;
}
function ReviewSaschafrommars({
  t
}: {
  t: TFunction;
}) {
  const {
    avatar,
    link
  } = useLocalisedTweetInfo('sascha');
  return <ReviewBox citation={<ReviewBox.TwitterCitation label={t('quoteSaschafrommars.name')} avatar={{
    src: avatar,
    alt: t('profilePictureAlt', {
      name: t('quoteSaschafrommars.name')
    })
  }} tweetLink={link} icon={SocialTwitter} />} data-sentry-element="ReviewBox" data-sentry-component="ReviewSaschafrommars" data-sentry-source-file="reviews.tsx">
            {<Interpolate t={t} i18nKey={'quoteSaschafrommars.quote'} />}
        </ReviewBox>;
}
function ReviewNJRun({
  t
}: {
  t: TFunction;
}) {
  return <ReviewBox citation={<ReviewBox.AppReviewCitation label={t('quoteNJRun.name')} icon={Apple} stars={5} starsAriaLabel={t('starsAriaLabel', {
    stars: 5
  })} />} data-sentry-element="ReviewBox" data-sentry-component="ReviewNJRun" data-sentry-source-file="reviews.tsx">
            {<Interpolate t={t} i18nKey={'quoteNJRun.quote'} />}
        </ReviewBox>;
}
function ReviewDayOneUser({
  t
}: {
  t: TFunction;
}) {
  return <ReviewBox citation={<ReviewBox.AppReviewCitation label={t('quoteDayOneUser.name')} icon={Apple} stars={5} starsAriaLabel={t('starsAriaLabel', {
    stars: 5
  })} />} data-sentry-element="ReviewBox" data-sentry-component="ReviewDayOneUser" data-sentry-source-file="reviews.tsx">
            {<Interpolate t={t} i18nKey={'quoteDayOneUser.quote'} />}
        </ReviewBox>;
}
function ReviewIammoinak({
  t
}: {
  t: TFunction;
}) {
  const {
    avatar,
    link
  } = useLocalisedTweetInfo('moinak');
  return <ReviewBox citation={<ReviewBox.TwitterCitation label={t('quoteIammoinak.name')} avatar={{
    src: avatar,
    alt: t('profilePictureAlt', {
      name: t('quoteIammoinak.name')
    })
  }} tweetLink={link} icon={SocialTwitter} />} data-sentry-element="ReviewBox" data-sentry-component="ReviewIammoinak" data-sentry-source-file="reviews.tsx">
            {<Interpolate t={t} i18nKey={'quoteIammoinak.quote'} />}
        </ReviewBox>;
}
export { ReviewAeravi, ReviewDayOneUser, ReviewEvnsio, ReviewIammoinak, ReviewKaiinde, ReviewNJRun, ReviewNotJulien, ReviewSaschafrommars };